module.exports = __webpack_public_path__ + "img/58_17.aee4149c.png";